import { Route, Routes } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { RcsRoutes } from 'pages/settings/pages/rcs/route/type'
import { RcsPage } from 'pages/settings/pages/rcs/ui/RcsPage'
import { RcsCreate } from 'pages/settings/pages/rcs/ui/RcsCreate'

export const RcsRouter = observer(() => {
  return (
    <Routes>
      <Route index element={<RcsPage />} />
      <Route path={`${RcsRoutes.create}`} element={<RcsCreate />} />
    </Routes>
  )
})
